<template>
  <v-container
    id="liga-forms"
    fluid
    tag="section"
  >
    <base-material-card
      color="#ac8a2e"
      icon="mdi-text-box-outline"
      inline
      class="px-5 py-3"
      title="Legales"
    >
      <v-row
        align="end"
        justify="end"
      >
        <v-col
          cols="5"
        >
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            class="ml-auto"
            color="gold"
            label="Buscar"
            hide-details
            single-line
            style="max-width: 250px;"
          />
        </v-col>
        <v-col
          cols="auto"
        >
          <v-dialog
            v-model="dialogDelete"
            max-width="500px"
          >
            <v-card>
              <v-card-title class="headline">
                ¿Realmente desea eliminar?
              </v-card-title>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="blue darken-1"
                  text
                  @click="closeDelete"
                >
                  Cancelar
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="deleteItemConfirm"
                >
                  Aceptar
                </v-btn>
                <v-spacer />
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
      <v-divider class="mt-3" />
        <v-col
          cols="auto"
        >
          <v-dialog
            v-model="dialog"
            max-width="500px"
          >
            <v-card>
              <v-card-title class="headline">
                ¿Realmente desea reabrir el litigio?
              </v-card-title>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="blue darken-1"
                  text
                  @click="close"
                >
                  Cancelar
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="openLetigioConfirm"
                >
                  Aceptar
                </v-btn>
                <v-spacer />
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      <v-data-table
        :headers="headers"
        :items="litigios"
        :search.sync="search"
        :sort-by="['fecha']"
        :sort-desc="[false, true]"
        multi-sort
      >
        <template v-slot:[`item.propio_sn`]="{ item }">
          <v-icon
            v-if="item.propio_sn"
            medium
            color="green"
          >
            mdi-checkbox-marked-circle-outline
          </v-icon>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip v-if="$can('M_legales_edita')" content-class="top" top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small v-bind="attrs" v-on="on" @click.stop="openLitigio(item)">
                mdi-undo-variant
              </v-icon>
            </template>
            <span>Reabrir Litigio</span>
          </v-tooltip>
          <v-tooltip content-class="top" top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small v-bind="attrs" v-on="on" @click.stop="goToHistorial(item.id)">
                mdi-forum
              </v-icon>
            </template>
            <span>Historial</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </base-material-card>
  </v-container>
</template>

<script>
  export default {
    data () {
      return {
        dialog: false,
        dialogDelete: false,
        search: undefined,
        headers: [
          { text: 'Fecha', sortable: true, value: 'fecha' },
          { text: 'Contraparte', sortable: true, value: 'contraparte' },
          { text: 'Propio', value: 'propio_sn' },
          { text: 'Acciones', value: 'actions', sortable: false, align: 'end' },
        ],
        litigios: [],
        editedIndex: -1,
        dataForm: {
          id: '',
          fecha: '',
          propio_sn: '',
          contraparte_user_id: '',
          contraparte_club_id: '',
          contraparte_otro: '',
          contraparte_contacto: '',
          detalle: '',
          documento_id: '',
          user_id: '',
          fecha_cierre: '',
          club: {
            id: '',
            descripcion: '',
          },
          user: {
            id: '',
            name: '',
          },
        },
      }
    },
    created () {
      this.getLitigios()
    },
    methods: {

      getLitigios: async function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/litigios_get_cerrados' }).then(response => { this.litigios = response })
      },

      goToHistorial: function (idLitigio) {
        this.$router.push({ name: 'Seguimiento legales', params: { id: idLitigio } })
      },

      deleteItem (item) {
        this.editedIndex = this.litigios.indexOf(item)
        this.dataForm = Object.assign({}, item)
        this.dialogDelete = true
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.dataForm = Object.assign({}, null)
          this.editedIndex = -1
        })
      },

      deleteItemConfirm: async function () {
        await this.$http.delete('/api/litigios_delete/' + this.dataForm.id,
                                {
                                  headers: { Authorization: 'Bearer ' + this.$store.state.token },
                                },
        ).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Litigio eliminado'] })
        }).catch(error => {
          if (error.response.data.errors) {
            this.$store.commit('toast/show', { tipo: 'error', messages: error.response.data.errors })
          } else {
            this.$store.commit('toast/show', { tipo: 'error', messages: ['Ocurrio un error en el servidor'] })
          }
        })
        this.getLitigios()
        this.closeDelete()
      },

      openLitigio (item) {
        this.dataForm = Object.assign({}, item)
        this.dialog = true
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      openLetigioConfirm: async function () {
        await this.$http.put('/api/litigio_abrir/' + this.dataForm.id).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Pedido de mercado abierto'] })
        }).catch(error => {
          if (error.response.data) {
            this.$store.commit('toast/show', { tipo: 'error', messages: [error.response.data] })
          } else {
            this.$store.commit('toast/show', { tipo: 'error', messages: ['Ocurrio un error en el servidor'] })
          }
        })
        this.getLitigios()
        this.close()
      },
    },
  }
</script>
